<template>
  <div>
    <template v-if="resp.results">
      <topsearch
        :title="'' + resp.results.name + ' #' + id"
        :favorite="favorite"
        :nextLeadId="nextLeadId"
      />
    </template>

    <div class="md:px-4 flex flex-col md:flex-row" v-if="resp.results">
      <div
        class="w-full pt-4 md:w-3/4 md:mr-4 md:pr-4 sm:border-b md:border-b-0 md:border-r"
      >
        <div
          class="  
        p-2
        md:p-0
        md:pb-4
        pb-4
        flex flex-col
        items-start
        md:flex-row
        space-y-4
        md:space-y-0
        justify-between 
      "
        >
          <div>
            <h1
              class="
            
            pl-2
            text-3xl
            border-tile-500
            flex
            items-center
            space-x-2
          "
            >
              <span>
                <vk-icon icon="user" />
              </span>
              <span>{{ resp.results.name }}</span>
            </h1>
            <div
              class="flex flex-col md:flex-row text-xl md:items-center justify-start md:space-x-2"
            >
              <span
                class=" pl-2 
              flex
              items-center
              space-x-2
            "
              >
                <span class="flex flex-col w-7 items-center  ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-7 h-7"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill="currentColor"
                      d="M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v5a2.5 2.5 0 0 1-2.5 2.5H8.688l-3.063 2.68A.98.98 0 0 1 4 13.942V12h-.5A2.5 2.5 0 0 1 1 9.5zM3.5 3A1.5 1.5 0 0 0 2 4.5v5A1.5 1.5 0 0 0 3.5 11H5v2.898L8.312 11H12.5A1.5 1.5 0 0 0 14 9.5v-5A1.5 1.5 0 0 0 12.5 3z"
                    />
                  </svg>
                  <span
                    class="absolute text-xs font-semibold mt-1 text-center  "
                    >{{ notSayisi }}</span
                  >
                </span>
                <template v-if="aranacakNo">
                  <template v-if="aranacakNo.length == 10">
                    <VDropdown>
                      <span
                        class="cursor-pointer flex text-xs items-center border space-x-2 rounded-lg p-1"
                      >
                        <svg
                          title="Hızlı arama"
                          alt="Hızlı arama"
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-6 h-6"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="currentColor"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                          >
                            <path
                              d="M22.75 7a5.75 5.75 0 1 0-10.9 2.56a.129.129 0 0 1 .013.04v.007l-.297 1.113a1.4 1.4 0 0 0 1.714 1.714l1.113-.298c-.002 0-.001 0 0 0h.007a.126.126 0 0 1 .04.014A5.75 5.75 0 0 0 22.75 7m-8.356 5.136h-.002zM17 2.75a4.25 4.25 0 1 1-1.892 8.057a1.567 1.567 0 0 0-1.102-.12l-.946.253l.253-.946a1.566 1.566 0 0 0-.12-1.102A4.25 4.25 0 0 1 17 2.75"
                            />
                            <path
                              d="M17 4.25a.75.75 0 0 1 .75.75v1.25H19a.75.75 0 0 1 0 1.5h-1.25V9a.75.75 0 0 1-1.5 0V7.75H15a.75.75 0 0 1 0-1.5h1.25V5a.75.75 0 0 1 .75-.75M3.007 6.407c1.68-1.68 4.516-1.552 5.685.544l.65 1.163c.763 1.368.438 3.095-.68 4.227a.63.63 0 0 0-.104.337c-.013.256.078.849.997 1.767c.918.918 1.51 1.01 1.767.997a.63.63 0 0 0 .337-.104c1.131-1.118 2.859-1.443 4.227-.68l1.163.65c2.096 1.17 2.224 4.005.544 5.685c-.899.898-2.094 1.697-3.498 1.75c-2.08.079-5.536-.459-8.958-3.88c-3.421-3.422-3.959-6.877-3.88-8.958c.053-1.405.852-2.6 1.75-3.498m4.376 1.275c-.6-1.074-2.21-1.32-3.315-.214c-.775.775-1.28 1.63-1.312 2.493c-.066 1.736.363 4.762 3.442 7.841c3.08 3.08 6.105 3.508 7.84 3.442c.863-.033 1.72-.537 2.494-1.312c1.106-1.106.86-2.716-.214-3.315l-1.163-.649c-.723-.403-1.74-.266-2.452.448c-.07.07-.517.486-1.308.524c-.81.04-1.791-.324-2.9-1.434c-1.111-1.11-1.475-2.091-1.435-2.902c.038-.791.455-1.237.524-1.306c.714-.714.851-1.73.448-2.453z"
                            />
                          </g>
                        </svg>
                        <span>Hızlı Ara</span>
                      </span>
                      <!-- This will be the content of the popover -->
                      <template #popper>
                        <div class="p-2 divide-y">
                          <div class="mb-4">
                            <select class="uk-select " v-model="aranacakNo">
                              <option>{{ resp.results.phone }}</option>
                              <option>{{ resp.results.phone_2 }}</option>
                              <option>{{ resp.results.mobile }}</option>
                            </select>
                          </div>

                          <div
                            class="text-sm cursor-pointer  p-2"
                            @click="makeCall(0)"
                          >
                            <span>İstanbul hattı</span>
                            <vk-spinner
                              v-if="loadingHat == 'hat0'"
                              ratio="0.5"
                            ></vk-spinner>
                          </div>
                          <div
                            class="text-sm cursor-pointer p-2"
                            @click="makeCall(80)"
                          >
                            <span>İzmir hattı</span>
                            <vk-spinner
                              v-if="loadingHat == 'hat80'"
                              ratio="0.5"
                            ></vk-spinner>
                          </div>
                          <div
                            class="text-sm  cursor-pointer  p-2"
                            @click="makeCall(90)"
                          >
                            <span>Ankara hattı</span>
                            <vk-spinner
                              v-if="loadingHat == 'hat90'"
                              ratio="0.5"
                            ></vk-spinner>
                          </div>
                          <div class="pt-2 text-gray-500">
                            <span
                              class="text-xs block w-60"
                              v-if="!$root.cache.me.dahili"
                              >Bu özellik çalışabilmesi için
                              <a href="/profile">profilinizde</a> dahiliniz
                              tanımlı olmalıdır.
                              {{ $root.cache.me.dahili }}</span
                            >
                            <span class="text-xs block w-60">
                              Lead detayındaki telefon bölümünde yazan numarayı
                              arar, aranacak numara :
                              {{ resp.results.phone }}</span
                            >
                          </div>
                        </div>
                      </template>
                    </VDropdown>
                  </template>
                  <template v-else>
                    <svg
                      title="Telefonu eksik yada fazla"
                      alt="Telefonu eksik yada fazla"
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M14.52 17.35C11.39 19.83 7.36 21.22 3 20.97v-5.51l5.27-.61l2.52 2.52c.81-.41 1.58-.9 2.3-1.45L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41zm1.39-4.24c.56-.73 1.05-1.51 1.47-2.33l-2.53-2.53l.61-5.25h5.51c.25 4.37-1.15 8.4-3.63 11.54z"
                      />
                    </svg>
                  </template>
                  <a
                    class="text-green-600 items-center border rounded-lg p-1 "
                    target="_blank"
                    v-if="resp.results.phone.length == 10"
                    :href="'https://wa.me/' + phonefix"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18c.21-.58.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01Z"
                      />
                    </svg> </a
                ></template>
              </span>
              <span
                class="
                items-center border rounded-lg p-1.5 text-sm
              pl-2 
              flex
              items-center
              space-x-2
            "
              >
                <vk-icon icon="mail" />
                <span>{{ resp.results.email }}</span>
              </span>
            </div>
          </div>
          <div>
            <span
              v-if="resp.results.is_customer == 0"
              @click="showCustomerForm()"
            >
              <savebutton
                action="convertCustomer"
                icon="star"
                title="Müşteriye dönüştür"
              >
              </savebutton>
            </span>
          </div>
        </div>
        <form autocomplete="off" @submit.prevent="convertCustomer()">
          <div
            v-if="showCustomerConverterForm"
            class="border border-t-2 bg-gray-50 bg-opacity-30  p-4 rounded-lg flex flex-col md:flex-row space-x-2 items-center md:items-start justify-between"
          >
            <div
              class="flex  p-4 flex-col items-center  justify-center rounded-lg space-x-2 mb-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-12 h-12  text-black"
                viewBox="0 0 48 48"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="4"
                >
                  <path
                    d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012z"
                  />
                  <path d="m17 24l5 5l10-10" />
                </g>
              </svg>

              <span class="text-black ">Müşteri Adayı Dönüştür </span>
            </div>

            <div class="flex-1">
              <div class="flex items-center space-x-2">
                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['retention_id']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['retention_id']"
                  :type="fieldsMap['retention_id'].component.name"
                />
                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['retention_md_id']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['retention_md_id']"
                  :type="fieldsMap['retention_md_id'].component.name"
                />
              </div>
              <div class="flex mt-4 items-center space-x-2">
                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['tc']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['tc']"
                  :type="fieldsMap['tc'].component.name"
                />

                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['occupation_id']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['occupation_id']"
                  :type="fieldsMap['occupation_id'].component.name"
                />
                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['city']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['city']"
                  :type="fieldsMap['city'].component.name"
                />

                <form-item
                  class="flex-1"
                  :form="customerConvertForm"
                  :input="fieldsMap['ilce']"
                  :label="true"
                  @changed="(g) => editFormSet(g)"
                  :value="customerConvertForm['ilce']"
                  :type="fieldsMap['ilce'].component.name"
                />
              </div>
            </div>

            <savebutton
              title="Dönüştür"
              @click="convertCustomer()"
              class="mt-4"
            />
          </div>
        </form>
        <div class="border-b border-gray-200 mb-2  dark:border-gray-700">
          <nav
            class="flex space-x-2 overflow-x-scroll md:overflow-hidden"
            aria-label="Tabs"
            role="tablist"
          >
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500':
                  'kisisel-bilgiler' == activeTab,
              }"
              class="font-semibold py-4 ml-2 md:ml-0 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-kisisel-bilgiler"
              @click="changeTab('kisisel-bilgiler')"
              data-hs-tab="#kisisel-bilgiler"
              aria-controls="kisisel-bilgiler"
              role="tab"
            >
              KİŞİSEL BİLGİLER
            </button>

            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'gorevler' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-gorevler"
              @click="changeTab('gorevler')"
              data-hs-tab="#gorevler"
              aria-controls="gorevler"
              role="tab"
              v-if="modules.includes('gorevler')"
            >
              GÖREVLER
            </button>
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'platformlar' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-platformlar"
              @click="changeTab('platformlar')"
              data-hs-tab="#platformlar"
              aria-controls="platformlar"
              role="tab"
              v-if="modules.includes('platformlar')"
            >
              PLATFORMLAR
            </button>
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'para-islemleri' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-para-islemleri"
              v-if="modules.includes('para-islemleri')"
              @click="changeTab('para-islemleri')"
              data-hs-tab="#para-islemleri"
              aria-controls="para-islemleri"
              role="tab"
            >
              PARA İŞLEMLERİ
            </button>
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500':
                  'eslesen-kayitlar' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-eslesen-kayitlar"
              @click="changeTab('eslesen-kayitlar')"
              data-hs-tab="#eslesen-kayitlar"
              aria-controls="eslesen-kayitlar"
              v-if="modules.includes('eslesen-kayitlar')"
              role="tab"
            >
              EŞLEŞEN KAYITLAR
            </button>
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'gecmis' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-gecmis"
              v-if="modules.includes('gecmis')"
              @click="changeTab('gecmis')"
              data-hs-tab="#gecmis"
              aria-controls="gecmis"
              role="tab"
            >
              GEÇMIŞ
            </button>
            <button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'dosyalar' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-dosyalar"
              v-if="modules.includes('dosyalar')"
              @click="changeTab('dosyalar')"
              data-hs-tab="#dosyalar"
              aria-controls="dosyalar"
              role="tab"
            >
              DOSYALAR</button
            ><button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500': 'anketler' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-anketler"
              v-if="modules.includes('anketler')"
              @click="changeTab('anketler')"
              data-hs-tab="#anketler"
              aria-controls="anketler"
              role="tab"
            >
              ANKETLER</button
            ><button
              type="button"
              :class="{
                ' border-tile-500 text-tile-500':
                  '3-sahis-bilgileri' == activeTab,
              }"
              class="font-semibold py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
              id="tab-3-sahis-bilgileri"
              v-if="modules.includes('3-sahis-bilgileri')"
              @click="changeTab('3-sahis-bilgileri')"
              data-hs-tab="#3-sahis-bilgileri"
              aria-controls="3-sahis-bilgileri"
              role="tab"
            >
              3. ŞAHIS BİLGİLERİ
            </button>
          </nav>
        </div>

        <div v-if="activeTab === 'kisisel-bilgiler'" class="text-sm">
          <form
            autocomplete="off"
            @submit="formSubmit()"
            v-if="editLead"
            class="leadEditForm"
            action="javascript:void(0)"
            method="post"
          >
            <div class="flex border-b pb-4   p-2 space-x-2">
              <form-item
                class="flex-1"
                :form="editForm"
                :input="fieldsMap['name']"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm['name']"
                :type="fieldsMap['name'].component.name"
              />
              <form-item
                class="flex-1"
                :form="editForm"
                :input="fieldsMap['phone']"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm['phone']"
                :type="fieldsMap['phone'].component.name"
              />
              <form-item
                class="flex-1"
                :form="editForm"
                :input="fieldsMap['status_id']"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm['status_id']"
                :type="fieldsMap['status_id'].component.name"
              />
              <form-item
                class="flex-1"
                :form="editForm"
                :input="fieldsMap['utm_source']"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm['utm_source']"
                :type="fieldsMap['utm_source'].component.name"
              />
              <form-item
                class="flex-1"
                :form="editForm"
                :input="fieldsMap['email']"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm['email']"
                :type="fieldsMap['email'].component.name"
              />
            </div>

            <div class="flex items-end flex-col">
              <savebutton
                action="formSubmit"
                class="p-2 my-4 -mt-2 absolute"
                style="margin-top: 10px"
              />
            </div>

            <section class="py-4" v-for="item in fieldsMapCat">
              <h2 class="text-sm px-2   uppercase text-tile font-normal">
                {{ item }}
              </h2>

              <div class="grid grid-cols-2 px-2 gap-6">
                <div
                  class="lead-item"
                  v-for="(key, val) in resp.results"
                  v-if="fieldsMap[val] && item == fieldsMap[val].category"
                >
                  <form-item
                    :form="editForm"
                    :input="fieldsMap[val]"
                    :label="true"
                    @changed="(g) => editFormSet(g)"
                    :value="editForm[val]"
                    :type="fieldsMap[val].component.name"
                  />
                </div>
              </div>
            </section>

            <savebutton
              action="formSubmit"
              class="p-2 my-4"
              style="margin-top: 10px"
            />
          </form>
          <div v-else>
            Detaylı bilgiler ve güncelleme yapmak için
            <span @click="editLead = true">
              buraya tıklayın
            </span>
          </div>
        </div>

        <DublicatedLeads :id="id" v-if="activeTab === 'eslesen-kayitlar'" />

        <Journals
          :id="id"
          v-if="activeTab === 'gecmis'"
          :fieldsMap="fieldsMap"
        />

        <Files :id="id" v-if="activeTab === 'dosyalar'" />
        <AccountsVue
          :id="id"
          :modules="modules"
          :lead="resp.results"
          v-if="activeTab === 'platformlar'"
        />

        <Questions :id="id" v-if="activeTab === 'anketler'" />
        <Transaction
          :id="id"
          v-if="activeTab === 'para-islemleri'"
          :lead="resp.results"
        />

        <Tasks :id="id" v-if="activeTab === 'gorevler'" />
        <Remitters :id="id" v-if="activeTab === '3-sahis-bilgileri'" />
      </div>
      <div
        class=" lead-detay-notes
          w-full
          border-t 
          mt-6
          md:mt-0
          pt-6
          md:pt-0 md:border-none md:w-1/4
        "
      >
        <vk-tabs>
          <vk-tabs-item v-if="modules.includes('notlar')" title="Notlar">
            <Notes
              @notSayisi="(e) => (notSayisi = e)"
              table="lead_notes"
              class="mt-4 text-sm"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
          <vk-tabs-item v-if="modules.includes('emailler')" title="E-Posta">
            <Emails
              table="lead_emails"
              class="mt-4 text-sm"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
          <vk-tabs-item v-if="modules.includes('notlar')" title="Hatırlatmalar">
            <Notifications
              table="notifications"
              class="mt-4 text-sm"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
        </vk-tabs>
      </div>
    </div>
    <div v-else>
      <div v-if="!loading">
        <div class="content-section min-h-screen flex">
          <div
            class="flex items-center mx-auto text-center justify-center flex-col"
          >
            <img src="/img/svg/not-found.svg" />

            <h2 class="m-0 p-0">404</h2>
            <h3 class="m-0 p-0">
              Böyle bir kayıt yok yada görmeye yetkili değilsiniz
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Journals from "../components/Ui/Lead/Journals";
import Files from "../components/Ui/Lead/Files";
import DublicatedLeads from "../components/Ui/Lead/DublicatedLeads";
import httpService from "../services/http";
import FormItemVue from "../components/Ui/FormItem";
import NotesVue from "../components/PageBuilder/Notes";
import Emails from "../components/PageBuilder/Emails";
import AccountsVue from "../modules/MetaTrader/Ui/Accounts";
import EventBus from "../components/Ui/EventBus";
import Questions from "../components/Ui/Lead/Questions";
import Tasks from "../components/Ui/Lead/Tasks";
import Transaction from "../components/Ui/Lead/Transaction";
import Remitters from "../components/Ui/Lead/Remitters";
import Notifications from "../components/PageBuilder/Notifications.vue";

export default {
  components: {
    "form-item": FormItemVue,
    AccountsVue,
    Notes: NotesVue,
    Journals,
    Emails,
    Files,
    DublicatedLeads,
    Notifications,
    Questions,
    Tasks,
    Transaction,
    Remitters,
  },
  data() {
    return {
      resp: {},
      aranacakNo: null,
      showCustomerConverterForm: false,
      editForm: [],
      customerConvertForm: [],
      fieldsMapCat: [],
      notSayisi: 0,
      nextLeadId: false,
      activeTab: this.getInitialTab(),
      duplicatedLeads: [],
      messages: [],
      modules: [],
      digerCrm: false,
      favorite: {},
      loading: true,
      loadingHat: "",
      phonefix: 0,
      leads_filters: [],
      editLead: true,
      fieldsMap: {},
    };
  },
  methods: {
    makeCall(ek) {
      this.loadingHat = "hat" + ek;
      httpService
        .makeCall({
          phone: ek + this.aranacakNo,
          lead_id: ek + this.resp.results.id,
        })
        .then((resp) => {
          this.loadingHat = "";
          console.log(resp, "resp");
        })
        .catch((e) => {
          this.loadingHat = "";
        });
    },
    showCustomerForm() {
      this.showCustomerConverterForm = !this.showCustomerConverterForm;
      this.customerConvertForm = this.editForm;
    },
    convertCustomer() {
      if (
        confirm(
          "Bu işlem geri alınamaz, bu başvuruyu müşteri yapmak istediğinize eminmisiniz ?"
        )
      ) {
        httpService
          .convertCustomer(this.editForm.id, this.customerConvertForm)
          .then((response) => {
            if (response.data.success) {
              EventBus.$emit("bottomMessage", {
                open: true,
                type: "success",
                title: "Yeni Müşteri",
                duration: 2000,
                body: "Tebrikler 1 müşteri daha kazandınız",
              });

              this.resp.results.is_customer = 1;
              this.showCustomerConverterForm = false;
              location.reload();
            }
          });
      }
    },
    formSubmit() {
      EventBus.$emit("loadingStatus", {
        action: "formSubmit",
        loading: true,
      });

      this.editForm.phone = this.formatPhoneNumber(this.editForm.phone);

      this.loading = true;
      httpService
        .detailSave({
          table: "leads",
          id: this.$route.params.id,
          inputs: this.editForm,
        })
        .then((response) => {
          if (response.data.success == true) {
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: true,
            });
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "success",
              duration: 2000,
              body: "Güncelleme başarılı",
            });
          } else {
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: false,
            });

            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
          }
        })
        .catch((e) => {
          EventBus.$emit("loadingStatus", {
            action: "formSubmit",
            loading: false,
            success: false,
          });

          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    editFormSet(val) {
      this.editForm[val.name] = val.value;
    },
    phoneFixSet() {
      this.phonefix = "90" + this.formatPhoneNumber(this.resp.results.phone);
      if (this.resp.results.phone) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.phone);
      } else if (this.resp.results.mobile) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.mobile);
      } else if (this.resp.results.phone_2) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.phone_2);
      }
    },
    formatPhoneNumber(phoneNumber) {
      let numericPart = phoneNumber.replace(/\D/g, "");
      numericPart = numericPart.startsWith("90")
        ? numericPart.slice(2)
        : numericPart;
      numericPart = numericPart.startsWith("0")
        ? numericPart.slice(1)
        : numericPart;
      return numericPart.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1$2$3$4");
    },
    changeTab(tab) {
      this.activeTab = tab;

      window.location.hash = tab;
    },
    getInitialTab() {
      // Sayfa yüklendiğinde, hash değerine göre aktif sekme belirle
      return window.location.hash.slice(1) || "kisisel-bilgiler";
    },

    getData(id) {
      if (this.$route.query.trx > 0) {
        httpService
          .getLeadDetail("leads", id, this.$route.query.trx)
          .then((resp) => {
            this.loading = false;
            this.resp = resp.data;
            this.editForm = this.resp.results;
            this.modules = this.resp.modules;
            this.phoneFixSet();

            this.favorite = {
              title: this.resp.results.name,
              url: "/leadDetail/" + this.resp.results.id,
            };
          });
      } else {
        httpService.getLeadDetail("leads", id, 0).then((resp) => {
          this.loading = false;
          this.resp = resp.data;
          this.editForm = this.resp.results;
          this.modules = this.resp.modules;
          this.phoneFixSet();

          this.favorite = {
            title: this.resp.results.name,
            url: "/leadDetail/" + this.resp.results.id,
          };
        });
      }
    },
  },
  mounted() {
    this.leads_filters = localStorage.getItem("leads_filters");

    httpService
      .getNextLead(JSON.parse(this.leads_filters), this.id)
      .then((resp) => {
        this.nextLeadId = resp.data.id;
      });

    EventBus.$on("reloadLead", (id) => {
      this.getData(id);
      this.$forceUpdate();
    });

    if (this.$route.hash) {
      this.$nextTick(() => {
        const element = document.querySelector(this.$route.hash);
        if (element) {
          element.click();
        }
      });
    }
  },
  async created() {
    this.table = "leads";

    this.id = this.$route.params.id;

    this.fieldsMapCat = new Set();

    await httpService.fields(this.table).then(async (resp) => {
      this.fields = resp.data;

      await this.fields.map((field) => {
        this.fieldsMap[field.name] = field;

        if (!this.fieldsMapCat.has(field.category)) {
          this.fieldsMapCat.add(field.category);
        }
      });
    });

    this.getData(this.$route.params.id);
  },
};
</script>

<style>
.edit-form-item {
  margin-bottom: 10px;
}

.lead-head {
  padding: 20px;
}

.lead-item h3 {
  margin: 0px;
  font-size: 15px;
  font-weight: 500;
  color: #222;
  padding: 0px;
  padding-top: 5px;
}

.lead-item div label {
  color: #555 !important;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
  text-transform: uppercase !important;
}

.leadEditForm {
  margin: 0px;
}

.leadEditForm ul {
  padding: 0px;
  margin: 0px;
}

.uk-heading-bullet {
  font-weight: 500;
}
</style>
